import { v as bvVar } from 'bv';

const {
  hasSportsbook = true,
  hasCasino = true,
  showTopLevelNavigation = true,
  homeProduct = 'sports',
  showQuickbetDefault = true,
  showBetslipAcceptAllPriceChanges = false,
  showBetslipAcceptAllLineChanges = false,
  kycLoginStrategies = '',
  generateHreflangs = true,
  extra6erSlug = 'extra6er',
  showKycBanner = true,
} = bvVar('siteConfigs').global || {};

export {
  hasSportsbook,
  hasCasino,
  showTopLevelNavigation,
  homeProduct,
  showQuickbetDefault,
  showBetslipAcceptAllPriceChanges,
  showBetslipAcceptAllLineChanges,
  kycLoginStrategies,
  generateHreflangs,
  extra6erSlug,
  showKycBanner,
};
